/* eslint-disable max-len */
/**
 * Finnish translations.
 */
export default {
  ACTION: {
    LINK_COPY: 'Kopioi'
  },
  ERROR: {},
  HEADER: {
    NAME: 'Nimi'
  },
  LABEL: {
    FILTER_MONTH_APR: 'Huhtikuu',
    FILTER_MONTH_AUG: 'Elokuu',
    FILTER_MONTH_DEC: 'Joulukuu',
    FILTER_MONTH_FEB: 'Helmikuu',
    FILTER_MONTH_JAN: 'Tammikuu',
    FILTER_MONTH_JUL: 'Heinäkuu',
    FILTER_MONTH_JUN: 'Kesäkuu',
    FILTER_MONTH_MAR: 'Maaliskuu',
    FILTER_MONTH_MAY: 'Toukokuu',
    FILTER_MONTH_NOV: 'Marraskuu',
    FILTER_MONTH_OCT: 'Lokakuu',
    FILTER_MONTH_SEP: 'Syyskuu',
    GENERATE_HASHTAG: 'Luo hashtag',
    GENERATE_LINK: 'Luo linkki',
    GENERATED_HASHTAG: 'Hashtag luotu',
    GENERATED_LINK: 'Generoitu linkki',
    MONTH: 'Kuukausi',
    NAME: 'Nimi',
    YEAR: 'Vuosi'
  },
  SENTENCE: {
    NO_ROWS_PRODUCTS: 'Ei tuotteita',
    NO_ROWS_PRODUCTS_DESCRIPTION: 'Muuta hakuehtoja'
  },
  SUCCESS: {
    HASHTAG_COPIED: 'Hashtag kopioitu',
    LINK_COPIED: 'Linkki kopioitu'
  },
  TOOLTIP: {
    MONTH: 'Kuukausi',
    NAME: 'Nimi',
    YEAR: 'Vuosi'
  }
};
